import { CommonModule } from '@angular/common';
import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IUniversalSearchItem } from 'app/shared/components/universal-search/interfaces/universal-search-item.interface';
import { Observable, startWith } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'upsc-universal-search-dialog',
    templateUrl: './universal-search-dialog.component.html',
    styleUrls: ['./universal-search-dialog.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
})
export class UniversalSearchDialogComponent implements OnInit {
    @HostBinding('class') public hostClass = 'universal-search-dialog';

    public inputControl = new FormControl<string | IUniversalSearchItem>(null);
    public options: IUniversalSearchItem[] = [];
    public filteredOptions: Observable<IUniversalSearchItem[]>;

    public constructor(public dialogRef: MatDialogRef<UniversalSearchDialogComponent>,
                       @Inject(MAT_DIALOG_DATA) public data: unknown,
    ) {
        this.options = data as IUniversalSearchItem[];
    }

    public ngOnInit(): void {
        this.filteredOptions = this.inputControl.valueChanges
                                   .pipe(
                                       startWith(''),
                                       map(value => {
                                           const searchText = typeof value === 'string' ? value : value?.text;
                                           return searchText ? this._filter(searchText) : this.options.slice();
                                       }),
                                   );
    }

    public displayFn(item: IUniversalSearchItem): string {
        return item && item.text ? item.text : '';
    }

    private _filter(searchText: string): IUniversalSearchItem[] {
        if (!searchText) {
            return [];
        }

        const filterValue = searchText.toLowerCase();
        return this.options.filter(option => option.text.toLowerCase().includes(filterValue));
    }

    public onOptionSelected(event: MatAutocompleteSelectedEvent): void {
        (event.option.value as IUniversalSearchItem).action();
        this.dialogRef.close();
    }
}
